module.exports = __webpack_public_path__ + "img/00007.ce3e2bc9.webp";